<div id="navigation" class="nav-inner">
  <p-menubar [model]="items" class="nav-menubar">
    <ng-template pTemplate="start">
      <a routerLink="/" class="brand flex items-center gap-2">
        <img src="../../../../assets/images/logo-header.svg" alt="Logo" class="h-[56px] w-auto"/>
      </a>
    </ng-template>
    <ng-template pTemplate="end">
      <div class="flex items-center gap-4">
        <app-client-switcher></app-client-switcher>
        <app-profile-icon></app-profile-icon>
      </div>
    </ng-template>
  </p-menubar>
</div>
